<template>
  <svg
    class="skill__icon--check"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 512.15"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Layer_2-2" data-name="Layer 2">
          <g id="Layer_1-2-2" data-name="Layer 1-2">
            <path
              class="svg-primary"
              d="M600,107.15c-3.8,15.73-15.46,25.77-26.22,36.52q-174.51,174.48-348.9,349c-9.15,9.15-18.63,17.29-31.88,19.52H181c-14.21-2.93-23.91-12.49-33.66-22.31q-60-60.4-120.42-120.47c-11-11-23-21.14-26.92-37.22v-16c.53-1,1-1.94,1.58-2.9,3.39-6,5.73-13,10.35-17.85,19.13-20,39-39.2,58.48-58.85,15.69-15.83,44.36-16,61.33,1.91s34.52,34.75,51.8,52.1c1.17,1.18,2.17,2.53,3.66,4.28,7.3-7.32,14.18-14.22,21.07-21.11Q338.14,143.82,467.89,13.79C486.17-4.6,514.33-4.65,532.22,14c17.55,18.25,35.64,36,53.7,53.74,7,6.92,11.16,15.29,14.08,24.46ZM535.16,53c-7.1-7.25-14.14-14.56-21.31-21.74-9.09-9.08-18.69-9-27.86.18q-40.14,40.1-80.26,80.21l-206.8,206.8c-8.27,8.27-14.51,8.3-22.69.16l-18-18c-15.09-15.08-30.08-30.26-45.31-45.2-7.66-7.52-17-8-24.49-1.08-8.16,7.57-15.73,15.77-23.56,23.69Q48.71,294,32.55,310c-10.36,10.29-10.31,19.2.08,29.59L172.91,479.78c9.87,9.86,19.38,9.81,29.35-.16L567,114.87c1.06-1.06,2.18-2.07,3.16-3.2,6.17-7.12,6.8-16.74.69-23.06C559.18,76.53,547.08,64.86,535.16,53Z"
            />
            <path
              class="svg-secondary"
              d="M535.16,53c11.92,11.84,24,23.51,35.69,35.59,6.11,6.32,5.48,15.94-.69,23.06-1,1.13-2.1,2.14-3.16,3.2L202.26,479.62c-10,10-19.48,10-29.35.16L32.6,339.52c-10.39-10.39-10.44-19.3-.08-29.59q16.11-16,32.33-31.91c1.5,1.3,3.08,2.52,4.48,3.92Q125.91,338.48,182.45,395c5.05,5.05,5.05,5.05,10,.13L530.35,57.29C531.83,55.77,533.54,54.44,535.16,53Z"
            />
            <path
              class="svg-secondary--low"
              d="M535.16,53c-1.62,1.42-3.33,2.75-4.84,4.27q-169,168.93-337.9,337.86c-4.92,4.92-4.92,4.92-10-.13Q125.9,338.49,69.33,281.94c-1.4-1.4-3-2.62-4.48-3.92,7.83-7.92,15.4-16.12,23.56-23.69,7.5-7,16.83-6.44,24.49,1.08,15.23,14.94,30.22,30.12,45.31,45.2l18,18c8.18,8.14,14.42,8.11,22.69-.16l206.8-206.8L486,31.44c9.17-9.16,18.77-9.26,27.86-.18C521,38.46,528.06,45.77,535.16,53Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "SvgIconSkillCheck",
  }
</script>
